export const Title = ({ name }) => {
  return <h2 className="font-headings md:text-7xl text-5xl m-5">{name}</h2>;
};
